/**
 * @generated SignedSource<<6f3771e1969c2dd39cf369fb9eeb895d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useChangeTeamMembershipLeaveMutation$variables = {
  teamId: string;
};
export type useChangeTeamMembershipLeaveMutation$data = {
  readonly me: {
    readonly leaveTeams: {
      readonly currentStoreUser: {
        readonly id: string;
        readonly teams: ReadonlyArray<{
          readonly id: string;
        }>;
      } | null;
      readonly id: string;
    };
  };
};
export type useChangeTeamMembershipLeaveMutation = {
  response: useChangeTeamMembershipLeaveMutation$data;
  variables: useChangeTeamMembershipLeaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeMutation",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "items": [
              {
                "kind": "Variable",
                "name": "teamIds.0",
                "variableName": "teamId"
              }
            ],
            "kind": "ListValue",
            "name": "teamIds"
          }
        ],
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "leaveTeams",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "currentStoreUser",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChangeTeamMembershipLeaveMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useChangeTeamMembershipLeaveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1dbdd630c1b10d41a96c4ade6f9137a3",
    "id": null,
    "metadata": {},
    "name": "useChangeTeamMembershipLeaveMutation",
    "operationKind": "mutation",
    "text": "mutation useChangeTeamMembershipLeaveMutation(\n  $teamId: ID!\n) {\n  me {\n    leaveTeams(teamIds: [$teamId]) {\n      id\n      currentStoreUser {\n        id\n        teams {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4789f9df163a3a24ae6188c45065a3d";

export default node;
